import {
  startCardReaderPaymentRequest,
  fetchCardReaderPaymentRequest,
  stopCardReaderPaymentRequest,
} from './api';

// Every answer carries the payment's `status`: pending, processing, stopping
// (keep polling), succeeded or failed (stop; `failure.code` says why).
export default {
  state: {},
  mutations: {},
  actions: {
    // Starting again while a payment for the order is still open answers with
    // that payment (same uuid), so a retry never prompts the reader twice.
    async startCardReaderPayment({ rootState }, { order }) {
      const { session } = rootState;
      const response = await startCardReaderPaymentRequest({ session, order });
      return response.data;
    },
    async fetchCardReaderPayment(_, { paymentUUID }) {
      const response = await fetchCardReaderPaymentRequest({ paymentUUID });
      return response.data;
    },
    // A request, not an outcome: keep polling until the payment is final.
    async stopCardReaderPayment(_, { paymentUUID }) {
      const response = await stopCardReaderPaymentRequest({ paymentUUID });
      return response.data;
    },
  },
};
